import type { TrTheme } from '@core/plugins/vuetify/theme/theme.interface'
import { ThemeComponentColors } from '@/config/themes/light/theme.componentColors'
import { ThemeVariables } from '@/config/themes/light/theme.variables'

export const Theme: TrTheme = {
  id: 'light',
  colors: { ...ThemeComponentColors },
  variables: { ...ThemeVariables }
}
